import { FetchError } from '@yandex-360/telemost-sdk';
import { put, spawn } from 'typed-redux-saga';

import { ErrorPageType } from '../../../../shared/components/error-page/types';
import { setErrorPageAction } from '../../../../shared/features/config';
import { toPassport } from '../../../../shared/features/user';
import { ConnectionErrors } from '../../types';
import { handleDisconnect } from './handle-disconnect';
import { handleKick } from './handle-kick';

export function* handleFetchError(error: unknown) {
    if (FetchError.is(error)) {
        if (error.status === 403) {
            if (
                error.error === ConnectionErrors.USER_KICKED_ERROR ||
                error.error === ConnectionErrors.USER_KICKED_WITH_BAN_ERROR
            ) {
                yield* spawn(handleKick);

                return true;
            }

            if (error.error === ConnectionErrors.ORGANIZATION_MISMATCHES_ERROR) {
                yield* put(setErrorPageAction({ type: ErrorPageType.ORGANIZATION_MISMATCHES }));
                yield* spawn(handleDisconnect);

                return true;
            }

            // Нет доступа
            yield* put(setErrorPageAction({ type: ErrorPageType.FORBIDDEN }));

            return true;
        } else if (error.status === 409) {
            // лимит участников
            yield* put(setErrorPageAction({ type: ErrorPageType.LIMIT_USERS_COUNT }));

            return true;
        } else if (error.status === 410) {
            // ссылка протухла
            yield* put(setErrorPageAction({ type: ErrorPageType.GONE }));

            return true;
        } else if (error.status === 404) {
            // такой конфы нет
            yield* put(setErrorPageAction({ type: ErrorPageType.NOT_FOUND }));

            return true;
        } else if (error.status === 401) {
            yield* put(toPassport());

            return true;
        }
    }

    return false;
}

const NON_CRITICAL_FORBIDDEN_ERROR: Maybe<string>[] = [
    ConnectionErrors.USER_KICKED_ERROR,
    ConnectionErrors.USER_KICKED_WITH_BAN_ERROR,
    ConnectionErrors.ORGANIZATION_MISMATCHES_ERROR,
];

export function isNonCriticalFetchError(error: unknown): boolean {
    return (
        FetchError.is(error) &&
        ((error.status === 403 && NON_CRITICAL_FORBIDDEN_ERROR.includes(error.error)) ||
            error.status === 401 ||
            error.status === 409)
    );
}
